export { default } from "./footer"